import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import colours from '../../tokens/colours';
import boxShadows from '../../tokens/boxShadows';
import { ITEM_HEIGHT } from './constants';
import stackOrder from '../../tokens/stackOrder';
export const getStyles = createUseStyles({
    root: {
        marginTop: 4,
        borderRadius: 4,
        backgroundColor: colours.septernary,
        overflow: 'hidden',
        position: 'absolute',
        left: 0,
        right: 0,
        maxHeight: 0,
        transition: ['max-height', '0.1s', 'linear'],
        transitionDelay: '0.1s',
        boxShadow: boxShadows.standard,
        overflowY: 'auto',
    },
    open: {
        maxHeight: ITEM_HEIGHT * 4,
        zIndex: stackOrder.dropdownMenu,
    },
});
const Menu = ({ isOpen, children }) => {
    const styles = getStyles();
    return (React.createElement("div", { className: classNames(styles.root, { [styles.open]: isOpen }) }, children));
};
export default Menu;
//# sourceMappingURL=Menu.js.map